export default __webpack_public_path__ + "static/media/logo-topo.1d91e35b.webp";